import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { I18n as AmplifyI18n } from 'aws-amplify'

import commonIt from './translations/it/translation.json'
import authIt from './auth/locale/it.json'
import commonEn from './translations/en/translation.json'
import authEn from './auth/locale/en.json'
import commonDe from './translations/de/translation.json'
import authDe from './auth/locale/de.json'
import commonFr from './translations/fr/translation.json'
import authFr from './auth/locale/fr.json'
import config from './config'

export const defaultLanguage = config.defaultLanguage

AmplifyI18n.setLanguage(defaultLanguage)

i18n.use(initReactI18next).init({
  resources: {
    it: {
      translation: commonIt,
      auth: authIt,
    },
    en: {
      translation: commonEn,
      auth: authEn,
    },
    de: {
      translation: commonDe,
      auth: authDe,
    },
    fr: {
      translation: commonFr,
      auth: authFr,
    },
  },
  lng: defaultLanguage,
  fallbackLng: defaultLanguage,
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
